import CompilationErrorAlert from './CompilationErrorAlert'

export default CompilationErrorAlert 